exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-table .echeance-depassee {\n  background:  #ffcf5a;\n}\n", ""]);

// exports
